export default __webpack_public_path__ + "static/media/test-failed-svgrepo-com.c093378f.svg";